export default {"src":"/_next/static/media/avatar-disabled.ffcbed8c.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};